<template>
  <div>
    <navbar />
    <div class="columns is-fullheight">
      <div class="column is-2 is-sidebar-menu is-hidden-mobile pt-0">
        <Sidebar/>
      </div>
      <div class="column is-main-content has-background-white ">
        <div class="m-3">
          <slot/>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Foot from '@/components/Foot'
import Sidebar from '@/components/Sidebar'

export default {
  name: 'LayoutBasic',

  data() {
    return {
      isActive: true,
      fullheight: true,
      expandOnHover: false,
      mobile: "reduce",
      reduce: false
    }
  },

  components: {
    Navbar,
    Foot,
    Sidebar
  }
}
</script>
